import { createApp } from 'vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

$(document).on('turbo:load turbo:render', () => {
  const productHistoryShow = document.querySelector('#product-history-show')
  if (productHistoryShow && !productHistoryShow.__vue_app__) {
    const scrollToSection = (sectionId) => {
      const section = document.getElementById(sectionId)
      const offset = 65
      const bodyRect = document.body.getBoundingClientRect().top
      const sectionRect = section.getBoundingClientRect().top
      const sectionPosition = sectionRect - bodyRect

      window.scrollTo({
        top: sectionPosition - offset,
        behavior: 'smooth'
      })
    }
    createApp({
      components: { BackButton },
      setup () {
        return {
          scrollToSection
        }
      }
    }).mount(productHistoryShow)
  }
})
